// App 加载完成
SR.App.on('onMount', function() {
    // core
    SR.modules.events();
    SR.modules.ask();
    SR.component.speak();
    SR.modules.answer = new SR.modules.answer;

    if (SR.state.mode === 'api' || SR.state.mode === 'modal') {
        SR.modules.autoAsk();
        return;
    }
    if (SR.state.mode === 'wakeup') {
        SR.component.tts();
        SR.component.geography();
        SR.component.toast = new SR.component.toast;
        return;
    }

    SR.debug.test = new SR.modules.debug;
    SR.modules.triggerAnalytics = new SR.modules.triggerAnalytics;
    SR.component.askBar();
    SR.component.loadHistory();
    SR.component.theater = new SR.component.theater;
    SR.component.toast = new SR.component.toast;

    setTimeout(function() {
        if (SR.state.theater) {
            var iTheaterScript = SR.modules.loadTheaterScript();
            SR.component.theater.play(iTheaterScript);
        } else {
            SR.state.categoryGuide && SR.component.slider();
            SR.component.guideQuestions();
        }
        SR.component.introduction();
    }, SR.data.componentLaunchDelay / 3);
    setTimeout(function() {
        SR.modules.autoAsk();
        SR.modules.randomQuestions();
        SR.component.autoComplete = new SR.component.autoComplete;  // 多处调用
        SR.component.tts();
        SR.component.videoPlayer();
        SR.component.geography();
        SR.component.share = new SR.component.share;
        window.getSuggestion = SR.component.autoComplete.getSuggestion; // 暴露给主线版本调用
        SR.component.voiceInput();
        SR.component.customerService();
        SR.component.tab();
        SR.component.like();
    }, SR.data.componentLaunchDelay);
    // debug tag
    SR.state.isDebug && SR.dom.$body.addClass('debug');
    (function disableCopy() {
        // contextmenu selectstart copy cut paste
        $(document).on('contextmenu selectstart', function(e) {
            return false;
        });
    })();
});